import React, { Fragment, useEffect, useState } from "react";

import FullScreenLoader from "./FullScreenLoader";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { getCompanies, getCompanyEmployees } from "../actions/companyActions";

import { getScheduleOfCompanyEmployee } from "../actions/companyEmployeeActions";

import FormErrorMessage from "../components/forms/FormErrorMessage";

import { Grid, Button } from "@material-ui/core";

import moment from "moment";
import { InputElementSize, InputElementType } from "../types/enums";
import InputElement from "./InputElement";

const CompanySchedule = (props) => {
  const [companyEmail, setCompanyEmail] = useState("");
  const [optionCompanies, setOptionCompanies] = useState([]);
  const [employees, setEmployees] = useState([]);

  const [showAllEmployees, setShowAllEmployees] = useState(false);

  const [beginDatetime, setBeginDatetime] = useState(moment().startOf("week"));
  const [endDatetime, setEndDatetime] = useState(moment().endOf("week"));

  const [isFetching, setIsFetching] = useState(false);

  const [days, setDays] = useState([
    moment().weekday(0),
    moment().weekday(1),
    moment().weekday(2),
    moment().weekday(3),
    moment().weekday(4),
    moment().weekday(5),
    moment().weekday(6),
  ]);

  useEffect(() => {
    refreshData();
  }, []);

  useEffect(() => {
    refreshSchedule();
  }, [companyEmail]);

  const refreshData = async () => {
    setIsFetching(true);
    setOptionCompanies([]);

    const companies = await props.getCompanies();

    setOptionCompanies(companies);

    refreshSchedule();
    setIsFetching(false);
  };

  const refreshSchedule = async () => {
    updateDays();
    if (!companyEmail) return;
    setIsFetching(true);
    setEmployees([]);

    let employees = await props.getCompanyEmployees(companyEmail, {
      paranoid: false,
    });

    const shifts = await Promise.all(
      employees.map((ce) =>
        props.getScheduleOfCompanyEmployee(
          companyEmail,
          ce.email,
          beginDatetime,
          endDatetime,
        ),
      ),
    );

    employees.forEach((employee, index) => {
      employee.shifts = shifts[index] || [];
    });
    setEmployees(employees);

    setIsFetching(false);
  };

  const updateDays = () => {
    const _days = days.map((d, i) => moment(beginDatetime).weekday(i));
    setDays(_days);
  };

  const previousWeek = () => {
    setBeginDatetime(beginDatetime.subtract(1, "week"));
    setEndDatetime(endDatetime.subtract(1, "week"));
    refreshSchedule();
  };

  const currentWeek = () => {
    setBeginDatetime(moment().startOf("week"));
    setEndDatetime(moment().endOf("week"));
    refreshSchedule();
  };

  const nextWeek = () => {
    setBeginDatetime(beginDatetime.add(1, "week"));
    setEndDatetime(endDatetime.add(1, "week"));
    refreshSchedule();
  };

  return (
    <Fragment>
      <Grid container spacing={3}>
        <InputElement
          key="companyEmail"
          item={{
            id: "companyEmail",
            label: "Bedrijf",
            type: InputElementType.SELECT,
            state: companyEmail,
            setState: setCompanyEmail,
            options: optionCompanies.map((o) => ({
              id: o.email,
              label: o.name,
            })),
          }}
        />

        <Grid item xs={12} sm={6}></Grid>

        <InputElement
          key="showAllEmployees"
          item={{
            id: "showAllEmployees",
            type: InputElementType.CHECKBOX,
            label: "Alle medewerkers",
            size: InputElementSize.S,
            state: showAllEmployees,
            setState: setShowAllEmployees,
          }}
        />

        <Grid item xs={12} sm={6}></Grid>
      </Grid>

      <br />

      <div style={{ textAlign: "center" }}>
        <Button onClick={previousWeek}>Vorige week</Button>
        <Button onClick={currentWeek}>Huidige week</Button>
        <Button onClick={nextWeek}>Volgende week</Button>
      </div>

      <br />

      <div className="horizontal-scroll-container">
        <table className="schedule-table">
          <thead>
            <tr>
              <td>Medewerker</td>
              {days.map((d) => (
                <td key={d.format("ddd DD MMM")}>{d.format("ddd DD MMM")}</td>
              ))}
            </tr>
          </thead>
          <tbody>
            {employees
              .filter(
                (employee) =>
                  !showAllEmployees ||
                  (!employee.companies[0].deletedAt && !employee.deletedAt),
              )
              .map((employee) => {
                if (showAllEmployees || employee.shifts.length) {
                  return (
                    <tr key={employee.email} height="100">
                      <td>
                        <a
                          href={`/company/${employee.companies[0].companyEmail}/employee/${employee.companies[0].employeeEmail}`}
                        >
                          {employee.firstName} {employee.lastName}
                        </a>
                      </td>
                      {days.map((day, i) => {
                        let shifts =
                          employee.shifts.filter(
                            (s) =>
                              day.isSame(
                                s.employees[0].CompanyEmployeeShift
                                  .startDateTime,
                                "day",
                              ) || day.isSame(s.beginDatetime, "day"),
                          ) || [];

                        return (
                          <td key={i}>
                            {shifts.map((s) => {
                              return (
                                <Fragment
                                  key={s.employees[0].CompanyEmployeeShift.id}
                                >
                                  <span>
                                    {moment(
                                      s.employees[0].CompanyEmployeeShift
                                        .startDateTime || s.beginDatetime,
                                    ).format("LT")}{" "}
                                    -{" "}
                                    {moment(
                                      s.employees[0].CompanyEmployeeShift
                                        .endDateTime || s.endDatetime,
                                    ).format("LT")}{" "}
                                    <br />
                                    <a
                                      href={`/company/${s.project.companyEmail}/project/${s.project.id}`}
                                    >
                                      {s.project.name}
                                    </a>
                                  </span>
                                  <br />
                                  <br />
                                </Fragment>
                              );
                            })}
                          </td>
                        );
                      })}
                    </tr>
                  );
                }
              })}
          </tbody>
        </table>
      </div>

      {isFetching && <FullScreenLoader />}

      {props.errorMessage && (
        <FormErrorMessage errorMessage={props.errorMessage} />
      )}
    </Fragment>
  );
};

CompanySchedule.propTypes = {
  getCompanies: PropTypes.func.isRequired,
  getCompanyEmployees: PropTypes.func.isRequired,
  getScheduleOfCompanyEmployee: PropTypes.func.isRequired,
  errorMessage: PropTypes.arrayOf(PropTypes.string),
};

const mapStateToProps = (state) => ({
  errorMessage:
    state.company.getCompanies.errorMessage ||
    state.company.getCompanyEmployees.errorMessage ||
    state.companyEmployee.getScheduleOfCompanyEmployee.errorMessage,
});

export default connect(mapStateToProps, {
  getCompanies,
  getCompanyEmployees,
  getScheduleOfCompanyEmployee,
})(CompanySchedule);



// WEBPACK FOOTER //
// ./src/components/CompanySchedule.js